export const ROUTES = {
    DEFAULT: '/',
    UNAUTHORIZE: '/app/login',
    LOGIN: '/login',
    RESET_PASSWORD: '/reset-password/:uid/:token/*',
    FORGOT_PASSWORD: '/forgot-password',
    HOME: '/home',
    PROFILE: '/profile',
    MY_CONTACTS: '/contacts',
    UN_AUTHORIZED: '/un-authorized',
    ACCEPT_INVITE: '/accept-invite/:token/*',
    ACCEPT_THRIVE_CART_INVITE: '/accept-thrive-cart-invite/:token/*',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    PRIVACY_POLICY: '/privacy-policy',
};
